import { z } from 'zod';

export const BalanceResponseSchema = z.number();

export type BalanceResponse = z.infer<typeof BalanceResponseSchema>;
